import React, { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { Section, Reveal } from "@/components/common/Section";
import ProductCard from "@/components/common/ProductCard";
import { getServicesByCategory } from "@/data/services";

export default function Orienteur() {
  const { t } = useLang();
  const [active, setActive] = useState("perso");
  const map = {
    perso: getServicesByCategory("particuliers"),
    pro: getServicesByCategory("professionnels"),
    avenir: getServicesByCategory("epargne"),
  };
  return (
    <Section tone="light" id="orienteur">
      <Reveal className="max-w-2xl">
        <h2 className="nek-h2">{t.orienteur.title}</h2>
        <p className="nek-intro mt-4">{t.orienteur.intro}</p>
      </Reveal>
      <div className="mt-8 flex flex-wrap gap-3" role="tablist">
        {t.orienteur.options.map((o) => (
          <button
            key={o.id}
            type="button"
            role="tab"
            aria-selected={active === o.id}
            onClick={() => setActive(o.id)}
            data-testid={`orienteur-${o.id}`}
            className={`rounded-full px-5 py-3 text-sm font-heading font-semibold transition-all ${
              active === o.id ? "bg-nek-navy text-white shadow-soft" : "border border-nek-border bg-white text-nek-navy hover:border-nek-blue"
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="orienteur-results">
        {map[active].map((s) => <ProductCard key={s.slug} service={s} ctaLabel={t.cta.studyNeed} />)}
      </div>
    </Section>
  );
}
